import React from "react";
import ImagerApi from "../../../api/ImagerApi";
import InfoIcon from "../../../Icons/NotificationMessage/Info";
import { getModuleStateById } from "../../../redux/reducers/ModuleStateReducer";
import { useTypedSelector } from "../../../redux/reducers/RootReducer";
import MtiButton from "../../Buttons/MtiButton";
import CommandPanel from "../../CommandPanel/CommandPanel";
import { PlateAddress } from "./../../../Model/PlateAddress";
import "./ClearDropLocation.css";

type Props = {
  plateAddress: PlateAddress;
  style?: React.CSSProperties;
  backBtn: (clearDropOverride: boolean) => void;
};

export default function ClearDropLocation({ plateAddress, backBtn, style = {} }: Props) {
  const suiteState = useTypedSelector((state) => getModuleStateById(state)["SUITE"]?.suite);
  const clearAllDrop = (clearDropOverride: boolean) => {
    const barcode = plateAddress.usedByPlate?.barcode ?? plateAddress.reservedByPlate?.barcode;
    if (barcode) {
      ImagerApi.clearDropLocation(barcode, clearDropOverride).finally(() => backBtn(clearDropOverride));
    }
  };

  return (
    <CommandPanel>
      <CommandPanel.PlateInfoHeader plateAddresses={[plateAddress]} />
      <CommandPanel.BackArrowHeader title="Clear Drop Location Position" onBackArrowClick={() => backBtn(false)} />
      <CommandPanel.VerticalContent>
        <div className="clear-drop-question">
          <p>
            Do you also want to remove the manual drop location overrides for this plate in{" "}
            {suiteState?.limsName ?? "LIMS"}?
          </p>
        </div>
        <div className="panel-info">
          <div className="icon">
            <InfoIcon fill="#956507" width={34} height={34} />
          </div>
          <div className="text">
            <p>This action will clear all drop locations in the plate.</p>
          </div>
        </div>
        <div className="buttons-clear-drop">
          <MtiButton size="large" onClick={() => clearAllDrop(true)}>
            Yes
          </MtiButton>
          <MtiButton size="large" onClick={() => clearAllDrop(false)}>
            No
          </MtiButton>
        </div>
      </CommandPanel.VerticalContent>
    </CommandPanel>
  );
}
